import React from 'react';
import './styles/ResetInfo.css';

/**
 * InfoValidateReset
 * Se renderiza dentro de un .tooltiptext — sin overlay ni posicionamiento propio.
 *
 * Props:
 *   hasPermission {boolean} — usuario tiene el permiso RESET
 *   hasConfig     {boolean} — object_id existe (configuración correcta)
 */
const InfoValidateReset = ({ hasPermission, hasConfig }) => {
  const allOk = hasPermission && hasConfig;

  return (
    <div className="ivr-wrap">

      {/* Header */}
      <div className={`ivr-header ${allOk ? 'ivr-header--ok' : 'ivr-header--warn'}`}>
        <div className="ivr-header-icon">
          {allOk ? (
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12"/>
            </svg>
          ) : (
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
              <line x1="12" y1="9" x2="12" y2="13"/>
              <line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
          )}
        </div>
        <div>
          <p className="ivr-header-title">
            {allOk ? 'Todo en orden' : 'Acción requerida'}
          </p>
          <p className="ivr-header-sub">
            {allOk
              ? 'Permisos y configuración activos.'
              : 'Revisa los puntos marcados.'}
          </p>
        </div>
      </div>

      {/* Items */}
      <div className="ivr-body">

        {/* ── Permisos ── */}
        <div className={`ivr-item ${hasPermission ? 'ivr-item--ok' : 'ivr-item--fail'}`}>
          <div className="ivr-item-icon">
            {hasPermission ? (
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
            ) : (
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            )}
          </div>
          <div className="ivr-item-content">
            <p className="ivr-item-title">Permisos de rol</p>
            {hasPermission ? (
              <p className="ivr-item-desc">Permiso RESET activo.</p>
            ) : (
              <>
                <p className="ivr-item-desc">Sin acceso. Pasos a seguir:</p>
                <ol className="ivr-steps">
                  <li>Ve a <strong>Configuración → Roles</strong></li>
                  <li>Selecciona el rol del usuario</li>
                  <li>Agrega el permiso requerido</li>
                  <li>Guarda y recarga la página</li>
                </ol>
              </>
            )}
          </div>
        </div>

        {/* ── Configuración ── */}
        <div className={`ivr-item ${hasConfig ? 'ivr-item--ok' : 'ivr-item--fail'}`}>
          <div className="ivr-item-icon">
            {hasConfig ? (
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
            ) : (
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            )}
          </div>
          <div className="ivr-item-content">
            <p className="ivr-item-title">Configuración</p>
            {hasConfig ? (
              <p className="ivr-item-desc">Afiliación sincronizada.</p>
            ) : (
              <>
                <p className="ivr-item-desc">Validar configuracion:</p>
                <ol className="ivr-steps">
                  <li>Revisa la afiliación que tiene registrada en Saimontech</li>
                  <li>Abre <strong>Reset Monitor</strong> y verifica el mismo campo</li>
                  <li>Asegúrate de que ambos valores sean idénticos</li>
                  <li>Si ambas afiliaciones son iguales , reportarlo con el equipo de saimontech</li>
                </ol>
              </>
            )}
          </div>
        </div>

      </div>
    </div>
  );
};

export default InfoValidateReset;